import $ from 'jquery';

import CurrencyConverter from 'shopify-currency-converter';

export default class Currency {
  constructor(section) {
    this.$el = $(section.el);
    $('[data-currency-converter]', this.$el).on('change.currency', (event) => {
      this.convertAll(event);
    });
  }

  convertAll(event) {
    CurrencyConverter.setCurrency(event.currentTarget.value);
    $('.selected-currency', this.$el).text(event.currentTarget.value);
  }

  unload() {
    $('[data-currency-converter]', this.$el).off('.currency');
  }
}
